var exports = {
  "container": "x43cbe9c2--47abf0--container",
  "wrapper": "x43cbe9c2--47abf0--wrapper",
  "textblock": "x43cbe9c2--47abf0--textblock",
  "title": "x43cbe9c2--47abf0--title",
  "description": "x43cbe9c2--47abf0--description",
  "image": "x43cbe9c2--47abf0--image",
  "tablet": "x43cbe9c2--47abf0--tablet",
  "phone": "x43cbe9c2--47abf0--phone",
};

module.exports = exports;
